<form #institutionsDataForm="ngForm" [formGroup]="orderHeaderFormGroup">
  <div class="cw-submodule">
    <!-- Modul-Titel -->
    <h3>{{ 'SHARED.ORDERTRACKING.JOBDATA' | translate }}</h3>
    <div class="cw-horizontalline"></div>

    <!-- Auftragsart -->
    @if (orderFormService.orderAccessRightsExplicit['order_type']['ngIf']) {
      <phscw-input-select
            [editMode]="
                orderFormService.orderAccessRightsExplicit['order_type']['editMode'] &&
                editMode &&
                orderDataCopy &&
                orderDataCopy.id === 0
            "
        [required]="orderFormService.orderAccessRightsExplicit['order_type']['required']"
        label="{{ 'GENERAL.ORDERTYPE' | translate }}"
        name="order_type"
        inputId="order_type"
        formControlName="order_type"
        listentries="orderType"
        [getListData]="true"
      (sendListDataEvent)="onChangedOrderTypeListData($event)"></phscw-input-select>
    }
    <!-- Status -->
    @if (orderFormService.orderAccessRightsExplicit['order_status']['ngIf']) {
      <phscw-input-select
        [editMode]="orderFormService.orderAccessRightsExplicit['order_status']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_status']['required']"
        label="{{ 'GENERAL.STATUS' | translate }}"
        name="order_status"
        inputId="order_status"
        formControlName="order_status"
      listentries="orderStatus"></phscw-input-select>
    }
    <!-- Auftragsnr. -->
    @if (orderFormService.orderAccessRightsExplicit['id']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['id']['required']"
        label="{{ 'GENERAL.ORDERID' | translate }}"
        name="id"
        inputId="id"
        formControlName="id"
      [hideEmpty]="false"></phscw-input-text>
    }
    <!-- ERP-Auftragsnr. -->
    @if (orderFormService.orderAccessRightsExplicit['erp_number']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['erp_number']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['erp_number']['required']"
        label="ERP-Auftragsnummer"
        name="erp_number"
        inputId="erp_number"
        formControlName="erp_number"
      [hideEmpty]="false"></phscw-input-text>
    }
    <!-- Sortiment -->
    @if (orderFormService.orderAccessRightsExplicit['order_range']['ngIf']) {
      <phscw-input-select
        [editMode]="orderFormService.orderAccessRightsExplicit['order_range']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_range']['required']"
        label="{{ 'GENERAL.ASSORTMENT' | translate }}"
        name="order_range"
        inputId="order_range"
        formControlName="order_range"
        listentries="orderRange"
      (change)="onChangedOrderRange()"></phscw-input-select>
    }
    <!-- Gebiet -->
    @if (orderFormService.orderAccessRightsExplicit['region_id']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['region_id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['region_id']['required']"
        label="{{ 'GENERAL.REGION' | translate }}"
        name="region_id"
        inputId="region_id"
      formControlName="region_id"></phscw-input-text>
    }
    <!-- Mandant -->
    @if (orderFormService.orderAccessRightsExplicit['company_code']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['company_code']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['company_code']['required']"
        label="{{ 'SHARED.ORDERTRACKING.COMPANYCODE' | translate }}"
        name="company_code"
        inputId="company_code"
      formControlName="company_code"></phscw-input-text>
    }
    <!-- Mitarbeiter -->
    @if (orderFormService.orderAccessRightsExplicit['employee_id']['ngIf']) {
      <phscw-input-autocomplete
        [editMode]="orderFormService.orderAccessRightsExplicit['employee_id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['employee_id']['required']"
        label="{{ 'SHARED.ORDERTRACKING.EMPLOYEE' | translate }}"
        name="employee_id"
        inputId="employee_id"
        formControlName="employee_id"
        backendLink="Employees/searchEmployeeForAutoComplete"
      [returnLabel]="true"></phscw-input-autocomplete>
    }
  </div>

  <div class="cw-submodule">
    <h3 class="header-margin">
      {{ 'SHARED.ORDERTRACKING.ORDERDATA' | translate }}
    </h3>
    <div class="cw-horizontalline"></div>

    <!-- Besteller Einrichtung -->
    @if (orderFormService.orderAccessRightsExplicit['order_institution_id']['ngIf']) {
      <phscw-input-autocomplete
        [editMode]="orderFormService.orderAccessRightsExplicit['order_institution_id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_institution_id']['required']"
        label="Besteller Einrichtung"
        name="order_institution_id"
        inputId="order_institution_id"
        formControlName="order_institution_id"
        backendLink="Institutions/searchInstitutionsForAutoComplete"
      [returnLabel]="false"></phscw-input-autocomplete>
    }

    <!-- Felder für Besteller-Adresse -->
    @if (orderFormService.orderAccessRightsExplicit['order_name']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['order_name']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_name']['required']"
        label="Besteller-Einrichtung Name"
        name="order_name"
        inputId="order_name"
        formControlName="order_name"
      [hideEmpty]="false"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['order_street']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['order_street']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_street']['required']"
        label="Besteller-Einrichtung Straße"
        name="order_street"
        inputId="order_street"
        formControlName="order_street"
      [hideEmpty]="false"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['order_zip_code']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['order_zip_code']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_zip_code']['required']"
        label="Besteller-Einrichtung PLZ"
        name="order_zip_code"
        inputId="order_zip_code"
        formControlName="order_zip_code"
      [hideEmpty]="false"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['order_city']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['order_city']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_city']['required']"
        label="Besteller-Einrichtung Stadt"
        name="order_city"
        inputId="order_city"
        formControlName="order_city"
      [hideEmpty]="false"></phscw-input-text>
    }

    <!-- ERP Kundennummer -->
    @if (orderFormService.orderAccessRightsExplicit['institution_erp_number']['ngIf']) {
      <phscw-input-select
        [editMode]="orderFormService.orderAccessRightsExplicit['institution_erp_number']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['institution_erp_number']['required']"
        label="ERP-Kundennummer"
        name="institution_erp_number"
        inputId="institution_erp_number"
        formControlName="institution_erp_number"
      [selectData]="institutionSupplementaryNumbers"></phscw-input-select>
    }
    <!-- Purchase Order Number -->
    @if (orderFormService.orderAccessRightsExplicit['purchase_order_number']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['purchase_order_number']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['purchase_order_number']['required']"
        label="{{ 'SHARED.ORDERTRACKING.CUSTOMERREFERENCE' | translate }}"
        name="purchase_order_number"
        inputId="purchase_order_number"
        [maxlength]="30"
        formControlName="purchase_order_number">
      </phscw-input-text>
    }
    <!-- Besteller Person -->
    @if (orderFormService.orderAccessRightsExplicit['order_person_name']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['order_person_name']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_person_name']['required']"
        label="Besteller Person"
        name="order_person_name"
        inputId="order_person_name"
      formControlName="order_person_name"></phscw-input-text>
    }
    <!-- Rabatt -->
    @if (orderFormService.orderAccessRightsExplicit['order_discount']['ngIf']) {
      <div
        class="cw-flex-row cw-discount-field"
        >
        <phscw-input-number
          [editMode]="orderFormService.orderAccessRightsExplicit['order_discount']['editMode'] && editMode"
          [required]="orderFormService.orderAccessRightsExplicit['order_discount']['required']"
          label="{{ 'SHARED.ORDERTRACKING.DISCOUNT' | translate }}"
          #orderDiscount
          name="order_discount"
          inputId="order_discount"
          formControlName="order_discount"
          [valueType]="'percent'"
          [hideEmpty]="false"
        [textAlign]="'left'"></phscw-input-number>
        <!-- Button zum Übertragen des Rabatts auf alle Auftragspositionen -->
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        @if (orderFormService.orderAccessRightsExplicit['order_discount']['editMode'] && editMode) {
          <button
            class="icon-arrow-down-from-line-solid cw-toolbar-icon"
            type="button"
          (click)="applyDiscount(orderDiscount.mathValue)"></button>
        }
      </div>
    }
    <!-- Bestelldatum -->
    @if (orderFormService.orderAccessRightsExplicit['order_date']['ngIf']) {
      <phscw-input-date
        [editMode]="orderFormService.orderAccessRightsExplicit['order_date']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['order_date']['required']"
        label="{{ 'SHARED.ORDERTRACKING.ORDERDATE' | translate }}"
        name="order_date"
        inputId="order_date"
      formControlName="order_date"></phscw-input-date>
    }
  </div>

  <div class="cw-submodule">
    <h3 class="header-margin">Rechnungsdaten</h3>
    <div class="cw-horizontalline"></div>

    <!-- Rechnungsempfänger -->
    @if (orderFormService.orderAccessRightsExplicit['invoice_institution_id']['ngIf']) {
      <phscw-input-autocomplete
        [editMode]="orderFormService.orderAccessRightsExplicit['invoice_institution_id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['invoice_institution_id']['required']"
        label="Rechnungsempfänger"
        name="invoice_institution_id"
        inputId="invoice_institution_id"
        formControlName="invoice_institution_id"
      backendLink="Institutions/searchInstitutionsForAutoComplete"></phscw-input-autocomplete>
    }

    <!-- Felder für Rechnungsadresse -->
    @if (orderFormService.orderAccessRightsExplicit['invoice_name']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['invoice_name']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['invoice_name']['required']"
        label="Rechnungsempfänger Name"
        name="invoice_name"
        inputId="invoice_name"
      formControlName="invoice_name"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['invoice_street']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['invoice_street']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['invoice_street']['required']"
        label="Rechnungsempfänger Straße"
        name="invoice_street"
        inputId="invoice_street"
      formControlName="invoice_street"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['invoice_zip_code']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['invoice_zip_code']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['invoice_zip_code']['required']"
        label="Rechnungsempfänger PLZ"
        name="invoice_zip_code"
        inputId="invoice_zip_code"
      formControlName="invoice_zip_code"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['invoice_city']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['invoice_city']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['invoice_city']['required']"
        label="Rechnungsempfänger Stadt"
        name="invoice_city"
        inputId="invoice_city"
      formControlName="invoice_city"></phscw-input-text>
    }

    <!-- Valuta -->
    @if (orderFormService.orderAccessRightsExplicit['valuta_date']['ngIf']) {
      <phscw-input-date
        [editMode]="orderFormService.orderAccessRightsExplicit['valuta_date']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['valuta_date']['required']"
        label="Valuta"
        name="valuta_date"
        inputId="valuta_date"
        formControlName="valuta_date">
      </phscw-input-date>
    }
    <!-- Zahlungsbedingung -->
    @if (orderFormService.orderAccessRightsExplicit['payment_condition']['ngIf']) {
      <phscw-input-select
        [editMode]="orderFormService.orderAccessRightsExplicit['payment_condition']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['payment_condition']['required']"
        label="{{ 'SHARED.ORDERTRACKING.VALUEDATE' | translate }}"
        name="payment_condition"
        inputId="payment_condition"
        formControlName="payment_condition"
      listentries="orderPaymentCondition"></phscw-input-select>
    }
    <!-- Bestellbestätigung -->
    @if (orderFormService.orderAccessRightsExplicit['confirmation']['ngIf']) {
      <phscw-input-single-checkbox
        [editMode]="orderFormService.orderAccessRightsExplicit['confirmation']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['confirmation']['required']"
        label="Bestellbestätigung"
        name="confirmation"
        inputId="confirmation"
      formControlName="confirmation"></phscw-input-single-checkbox>
    }
    <!-- Einen Kontakt zusammen mit dem Auftrag anlegen? Nur bei neuen Aufträgen & wenn die Auftragsart erlaubt ist -->
    @if (orderFormService.orderAccessRightsExplicit['create_contacts_for_order_types']['ngIf'] && (orderHeaderFormGroup.get('id')?.value ?? 0) === 0) {
      <phscw-input-single-checkbox
        [editMode]="orderFormService.orderAccessRightsExplicit['create_contacts_for_order_types']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['create_contacts_for_order_types']['required']"
        label="Kontakt anlegen"
        name="create_contacts_for_order_types"
        inputId="create_contacts_for_order_types"
      formControlName="create_contacts_for_order_types"></phscw-input-single-checkbox>
    }
    <!-- Kontaktmethode auswählen -->
    @if (orderHeaderFormGroup.get('create_contacts_for_order_types')?.value && orderFormService.orderAccessRightsExplicit['create_contacts_for_order_types']['ngIf']) {
      <phscw-input-select
        [editMode]="orderHeaderFormGroup.get('create_contacts_for_order_types')?.value && editMode"
        [required]="orderHeaderFormGroup.get('create_contacts_for_order_types')?.value"
        label="{{ 'GENERAL.CONTACTMETHOD' | translate }} "
        name="contact_method"
        inputId="contact_method"
        listentries="contactMethod"
      formControlName="contact_method"></phscw-input-select>
    }
  </div>

  <div class="cw-submodule">
    <!-- Modul-Titel -->
    <h3>Lieferdaten</h3>
    <div class="cw-horizontalline"></div>

    <!-- Großhändler -->
    @if (orderFormService.orderAccessRightsExplicit['wholesaler_institution_id']['ngIf']) {
      <phscw-input-autocomplete
        [editMode]="orderFormService.orderAccessRightsExplicit['wholesaler_institution_id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['wholesaler_institution_id']['required']"
        label="{{ 'SHARED.ORDERTRACKING.WHOLESALER' | translate }}"
        name="wholesaler_institution_id"
        inputId="wholesaler_institution_id"
        formControlName="wholesaler_institution_id"
        backendLink="InstitutionsOrders2/searchWholesalerForAutoComplete"
        [returnLabel]="false">
      </phscw-input-autocomplete>
    }

    <!-- Felder für Großhändler-Adresse -->
    @if (orderFormService.orderAccessRightsExplicit['wholesaler_name']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['wholesaler_name']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['wholesaler_name']['required']"
        label="Großhändler Name"
        name="wholesaler_name"
        inputId="wholesaler_name"
      formControlName="wholesaler_name"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['wholesaler_street']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['wholesaler_street']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['wholesaler_street']['required']"
        label="Großhändler Straße"
        name="wholesaler_street"
        inputId="wholesaler_street"
      formControlName="wholesaler_street"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['wholesaler_zip_code']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['wholesaler_zip_code']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['wholesaler_zip_code']['required']"
        label="Großhändler PLZ"
        name="wholesaler_zip_code"
        inputId="wholesaler_zip_code"
      formControlName="wholesaler_zip_code"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['wholesaler_city']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['wholesaler_city']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['wholesaler_city']['required']"
        label="Großhändler Stadt"
        name="wholesaler_city"
        inputId="wholesaler_city"
      formControlName="wholesaler_city"></phscw-input-text>
    }

    <!-- Dekorateur -->
    @if (orderFormService.orderAccessRightsExplicit['dekorateur']['ngIf']) {
      <phscw-input-autocomplete
        [editMode]="orderFormService.orderAccessRightsExplicit['dekorateur']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['dekorateur']['required']"
        label="Dekorateur"
        name="dekorateur"
        inputId="dekorateur"
        backendLink="Institutions/searchInstitutionsForAutoComplete"
        [returnLabel]="true">
      </phscw-input-autocomplete>
    }

    <!-- Lieferempfänger -->
    @if (orderFormService.orderAccessRightsExplicit['delivery_institution_id']['ngIf']) {
      <phscw-input-select
        [editMode]="orderFormService.orderAccessRightsExplicit['delivery_institution_id']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['delivery_institution_id']['required']"
        label="{{ 'SHARED.ORDERTRACKING.DELIVERYADDRESS' | translate }}"
        name="delivery_institution_id"
        inputId="delivery_institution_id"
        formControlName="delivery_institution_id"
        [automaticFirstSelection]="true"
        [selectData]="deliveryInstitutionSelectData">
      </phscw-input-select>
    }

    <!-- Felder für Lieferadresse -->
    @if (orderFormService.orderAccessRightsExplicit['delivery_name']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['delivery_name']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['delivery_name']['required']"
        label="Lieferempfänger Name"
        name="delivery_name"
        inputId="delivery_name"
      formControlName="delivery_name"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['delivery_street']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['delivery_street']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['delivery_street']['required']"
        label="Lieferempfänger Straße"
        name="delivery_street"
        inputId="delivery_street"
      formControlName="delivery_street"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['delivery_zip_code']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['delivery_zip_code']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['delivery_zip_code']['required']"
        label="Lieferempfänger PLZ"
        name="delivery_zip_code"
        inputId="delivery_zip_code"
      formControlName="delivery_zip_code"></phscw-input-text>
    }
    @if (orderFormService.orderAccessRightsExplicit['delivery_city']['ngIf']) {
      <phscw-input-text
        [editMode]="orderFormService.orderAccessRightsExplicit['delivery_city']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['delivery_city']['required']"
        label="Lieferempfänger Stadt"
        name="delivery_city"
        inputId="delivery_city"
      formControlName="delivery_city"></phscw-input-text>
    }

    <!-- Lieferdatum 1 .. n -->
    <div formArrayName="delivery_dates">
      @for (date of this.deliveryDatesFormArray.controls; track date; let i = $index; let isLast = $last) {
        <div>
          @if (
            orderFormService.orderAccessRightsExplicit['delivery_dates']['ngIf'] &&
            deliveryDates.length <= orderFormService.maxDeliveryDates
            ) {
            <phscw-input-date
              [editMode]="orderFormService.orderAccessRightsExplicit['delivery_dates']['editMode'] && editMode"
              [required]="orderFormService.orderAccessRightsExplicit['delivery_dates']['required']"
              label="{{ ('SHARED.ORDERTRACKING.DELIVERYDATE' | translate) + ' ' + (i + 1) }}"
              [formControlName]="i"
              [showDeleteButton]="i > 0 && isLast"
              [inputReadonly]="true"
            (deleteClicked)="removeDeliveryDate(i)"></phscw-input-date>
          }
        </div>
      }
      @if (
        editMode &&
        orderFormService.orderAccessRightsExplicit['delivery_dates']['ngIf'] &&
        deliveryDates.length < orderFormService.maxDeliveryDates
        ) {
        <button
          mat-button
          matTooltip="{{ 'SHARED.TOOLBAR.ADDNEW' | translate }}"
          (click)="addDeliveryDate()">
          <span class="icon-plus"></span>
        </button>
      }
    </div>
  </div>

  <div class="cw-submodule">
    <!-- Modul-Titel -->
    <h3>Hinweise</h3>
    <div class="cw-horizontalline"></div>

    <!-- Interner Hinweis -->
    @if (orderFormService.orderAccessRightsExplicit['text']['ngIf']) {
      <phscw-input-textarea
        [editMode]="orderFormService.orderAccessRightsExplicit['text']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['text']['required']"
        class="cw-flex-row cw-input"
        label="{{ 'SHARED.ORDERTRACKING.NOTE' | translate }} intern"
        name="text"
        inputId="text"
        formControlName="text"
      [rows]="5"></phscw-input-textarea>
    }
    <!-- Externer Hinweis -->
    @if (orderFormService.orderAccessRightsExplicit['text_extern']['ngIf']) {
      <phscw-input-textarea
        [editMode]="orderFormService.orderAccessRightsExplicit['text_extern']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['text_extern']['required']"
        class="cw-flex-row cw-input"
        label="{{ 'SHARED.ORDERTRACKING.NOTE' | translate }} extern"
        name="text_extern"
        inputId="text_extern"
        formControlName="text_extern"
      [rows]="5"></phscw-input-textarea>
    }
    <!-- Aktion -->
    @if (orderFormService.orderAccessRightsExplicit['campaign']['ngIf']) {
      <phscw-input-select
        [editMode]="orderFormService.orderAccessRightsExplicit['campaign']['editMode'] && editMode"
        [required]="orderFormService.orderAccessRightsExplicit['campaign']['required']"
        label="Aktion"
        name="campaign"
        inputId="campaign"
        formControlName="campaign"
      listentries="orderCampaign"></phscw-input-select>
    }
  </div>
</form>
